/**
 * Kontaktieren via: E-Mail + Benachrichtigung (Lux), hide Portal, preference rules on toggle/save.
 * Impower legacy PORTAL has no Lux effect (not Benachrichtigung, not Versand).
 */
function initKontaktierenViaDispatchPreferences(options) {
  const mode = options?.mode === 'view' ? 'view' : 'edit'
  const getContactId =
    typeof options?.getContactId === 'function' ? options.getContactId : () => null

  // Normalize order (PORTAL legacy only; not shown in edit UI)
  const PREF_ORDER = ['PORTAL', 'EMAIL', 'MANUAL', 'EPOST', 'BENACHRICHTIGUNG']
  const VISIBLE_PREFS = ['EMAIL', 'MANUAL', 'EPOST', 'BENACHRICHTIGUNG']
  const PERSIST_ORDER = ['EMAIL', 'MANUAL', 'EPOST', 'BENACHRICHTIGUNG']
  const LABELS = {
    PORTAL: 'Benachrichtigung',
    EMAIL: 'E-Mail',
    MANUAL: 'Manuell',
    EPOST: 'E-Post',
    BENACHRICHTIGUNG: 'Benachrichtigung',
  }
  const ATTR = 'data-lux-kontaktieren-via'
  const API_PATH = '/api/impowerX/contacts/lux-dispatch-preferences'

  const getAuthToken = () => {
    try {
      return JSON.parse(localStorage.getItem('auth') || '{}')?.token || null
    } catch {
      return null
    }
  }

  const normalizePrefs = (prefs) => {
    if (!Array.isArray(prefs)) return []
    const present = new Set()
    prefs.forEach((raw) => {
      if (typeof raw !== 'string') return
      const token = raw.trim().toUpperCase()
      if (PREF_ORDER.includes(token)) present.add(token)
    })
    return PREF_ORDER.filter((p) => present.has(p))
  }

  /** Sanitize — EPOST > MANUAL; EMAIL may combine with EPOST; Benachrichtigung never with E-Mail. */
  const resolveValidPrefs = (prefs) => {
    const set = new Set(normalizePrefs(prefs))
    const wantBenachrichtigung = set.has('BENACHRICHTIGUNG')
    const hasEpost = set.has('EPOST')
    const hasManual = set.has('MANUAL') && !hasEpost
    const hasEmail = set.has('EMAIL') && !hasManual

    const result = []
    if (hasEmail) result.push('EMAIL')
    if (hasManual) result.push('MANUAL')
    if (hasEpost) result.push('EPOST')
    if (wantBenachrichtigung && !hasEmail && (hasEpost || hasManual)) {
      result.push('BENACHRICHTIGUNG')
    }
    return PERSIST_ORDER.filter((p) => result.includes(p))
  }

  /** Flip token; EMAIL+EPOST allowed; Manual/E-Post (without E-Mail) select Benachrichtigung. */
  const togglePref = (current, token) => {
    const upper = String(token || '')
      .trim()
      .toUpperCase()
    if (!PREF_ORDER.includes(upper)) return resolveValidPrefs(current)

    const next = new Set(normalizePrefs(current))
    const turningOn = !next.has(upper)

    if (turningOn) {
      next.add(upper)
      if (upper === 'EMAIL') {
        next.delete('MANUAL')
        next.delete('PORTAL')
        next.delete('BENACHRICHTIGUNG')
      } else if (upper === 'EPOST') {
        next.delete('MANUAL')
        next.delete('PORTAL')
        if (next.has('EMAIL')) {
          next.delete('BENACHRICHTIGUNG')
        } else {
          next.add('BENACHRICHTIGUNG')
        }
      } else if (upper === 'MANUAL') {
        next.delete('EPOST')
        next.delete('EMAIL')
        next.add('BENACHRICHTIGUNG')
      } else if (upper === 'BENACHRICHTIGUNG') {
        next.delete('EMAIL')
        if (!next.has('EPOST') && !next.has('MANUAL')) {
          next.add('MANUAL')
        }
      } else if (upper === 'PORTAL') {
        // Legacy Impower — do not map to Lux Benachrichtigung
        next.delete('PORTAL')
      }
    } else {
      next.delete(upper)
    }

    return resolveValidPrefs(Array.from(next))
  }

  /** Display: priority-sanitize (legacy multi-checked → one valid combo). */
  const prefsForDisplay = (prefs) => resolveValidPrefs(prefs)

  /** Raw saved visible tokens (no priority sanitize) — for dirty detection on open. */
  const prefsAsSavedVisible = (prefs) => {
    const set = new Set(normalizePrefs(prefs))
    set.delete('PORTAL')
    return VISIBLE_PREFS.filter((p) => set.has(p))
  }

  /** Impower LetterDispatchType only: MANUAL / EPOST (never EMAIL, BENACHRICHTIGUNG, PORTAL). */
  const toImpowerPrefs = (prefs) => {
    const resolved = resolveValidPrefs(prefs)
    if (resolved.includes('EPOST')) return ['EPOST']
    if (resolved.includes('MANUAL')) return ['MANUAL']
    return []
  }

  const resolveEffective = (luxPrefs, impowerPrefs) => {
    if (luxPrefs != null) return normalizePrefs(luxPrefs)
    return normalizePrefs(impowerPrefs || [])
  }

  const formatLabels = (prefs) => {
    const forDisplay = prefsForDisplay(prefs)
    if (forDisplay.length === 0) return '—'
    return forDisplay.map((p) => LABELS[p]).join(', ')
  }

  const findKontaktierenViaLabelEl = (root) => {
    const scope = root || document
    const scoped =
      scope.querySelector?.('.PersonData, .CompanyData, .ant-card.data-card') || scope
    const candidates = scoped.querySelectorAll('.label, .sub-section-title')
    for (const el of candidates) {
      if (el.closest('[data-impowerx-view-contact-options], [data-lux-kontaktieren-via="view-value"]')) {
        continue
      }
      if (el.childNodes.length === 1 && el.textContent && el.textContent.trim() === 'Kontaktieren via') {
        return el
      }
      if (
        el.children.length === 0 &&
        el.textContent &&
        el.textContent.trim() === 'Kontaktieren via'
      ) {
        return el
      }
    }
    return null
  }

  const getImpowerCheckedPrefsFromDom = (groupRoot) => {
    const prefs = []
    ;['PORTAL', 'EPOST', 'MANUAL'].forEach((value) => {
      const input = groupRoot.querySelector(`input[type="checkbox"][value="${value}"]`)
      if (input?.checked) prefs.push(value)
    })
    return prefs
  }

  const readVisibleCheckedPrefs = (groupRoot) => {
    const prefs = []
    VISIBLE_PREFS.forEach((value) => {
      const input = groupRoot.querySelector(`input[type="checkbox"][value="${value}"]`)
      if (input?.checked) prefs.push(value)
    })
    return prefs
  }

  const applyCheckedState = (input, checked) => {
    if (!input) return
    input.checked = Boolean(checked)
    const ant = input.closest('.ant-checkbox')
    const wrap = input.closest('.ant-checkbox-wrapper')
    ant?.classList.toggle('ant-checkbox-checked', Boolean(checked))
    wrap?.classList.toggle('ant-checkbox-wrapper-checked', Boolean(checked))
  }

  const syncCheckboxTo = (input, wantChecked) => {
    if (!input) return
    const ant = input.closest('.ant-checkbox')
    const isOn =
      Boolean(input.checked) || !!ant?.classList.contains('ant-checkbox-checked')
    if (isOn !== Boolean(wantChecked)) {
      input.click()
    }
    // Impower React often leaves input.checked false — force visual + checked for Lux reads
    applyCheckedState(input, wantChecked)
  }

  const ensureLuxCheckboxStyles = () => {
    if (document.getElementById('lux-kontaktieren-via-email-style')) return
    const style = document.createElement('style')
    style.id = 'lux-kontaktieren-via-email-style'
    style.textContent = `
      [${ATTR}="email-label"],
      [${ATTR}="benachrichtigung-label"] {
        cursor: pointer;
        display: inline-flex;
        align-items: center;
      }
      [${ATTR}="email-label"] .ant-checkbox,
      [${ATTR}="benachrichtigung-label"] .ant-checkbox {
        position: relative;
        top: 0;
      }
      [${ATTR}="email-label"] .ant-checkbox-input,
      [${ATTR}="benachrichtigung-label"] .ant-checkbox-input {
        position: absolute;
        inset: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
        margin: 0;
      }
      [${ATTR}="portal-hidden"] {
        display: none !important;
      }
    `
    document.head.appendChild(style)
  }

  const createLuxCheckbox = (value, labelText, attrName) => {
    ensureLuxCheckboxStyles()
    const label = document.createElement('label')
    label.className =
      'ant-checkbox-wrapper ant-checkbox-wrapper-in-form-item ant-checkbox-group-item'
    label.setAttribute(ATTR, `${attrName}-label`)
    label.innerHTML = `
      <span class="ant-checkbox" ${ATTR}="${attrName}-box">
        <input type="checkbox" class="ant-checkbox-input" value="${value}" ${ATTR}="${attrName}-input" />
        <span class="ant-checkbox-inner"></span>
      </span>
      <span>${labelText}</span>
    `
    return label
  }

  const bindLuxOwnedCheckbox = (input, token, onAfterToggle) => {
    if (!input || input.dataset.luxKontaktierenOwnedBound === '1') return
    input.dataset.luxKontaktierenOwnedBound = '1'
    const label = input.closest('label')
    label?.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()
      if (!saveState.groupRoot) return
      const current = saveState.lastPrefs || readVisibleCheckedPrefs(saveState.groupRoot)
      const next = togglePref(current, token)
      applyPrefsToUi(saveState.groupRoot, next, { syncImpower: true })
      onAfterToggle?.()
    })
  }

  const applyPrefsToUi = (groupRoot, prefs, { syncImpower = false } = {}) => {
    const display = prefsForDisplay(prefs)
    const prevApplying = saveState.applyingRules
    // While syncing Impower boxes, allow native clicks through — do not re-toggle
    saveState.applyingRules = true
    try {
      applyCheckedState(
        groupRoot.querySelector(`input[type="checkbox"][value="EMAIL"]`),
        display.includes('EMAIL'),
      )
      applyCheckedState(
        groupRoot.querySelector(`input[type="checkbox"][value="BENACHRICHTIGUNG"]`),
        display.includes('BENACHRICHTIGUNG'),
      )
      if (syncImpower) {
        syncCheckboxTo(
          groupRoot.querySelector('input[type="checkbox"][value="MANUAL"]'),
          display.includes('MANUAL'),
        )
        syncCheckboxTo(
          groupRoot.querySelector('input[type="checkbox"][value="EPOST"]'),
          display.includes('EPOST'),
        )
        syncCheckboxTo(groupRoot.querySelector('input[type="checkbox"][value="PORTAL"]'), false)
        // Impower React may re-paint after our clicks — re-assert visual state
        const paint = () => {
          applyCheckedState(
            groupRoot.querySelector('input[type="checkbox"][value="MANUAL"]'),
            display.includes('MANUAL'),
          )
          applyCheckedState(
            groupRoot.querySelector('input[type="checkbox"][value="EPOST"]'),
            display.includes('EPOST'),
          )
          applyCheckedState(groupRoot.querySelector('input[type="checkbox"][value="PORTAL"]'), false)
          applyCheckedState(
            groupRoot.querySelector(`input[type="checkbox"][value="EMAIL"]`),
            display.includes('EMAIL'),
          )
          applyCheckedState(
            groupRoot.querySelector(`input[type="checkbox"][value="BENACHRICHTIGUNG"]`),
            display.includes('BENACHRICHTIGUNG'),
          )
        }
        paint()
        requestAnimationFrame(() => {
          paint()
          setTimeout(paint, 0)
        })
      } else {
        applyCheckedState(
          groupRoot.querySelector('input[type="checkbox"][value="MANUAL"]'),
          display.includes('MANUAL'),
        )
        applyCheckedState(
          groupRoot.querySelector('input[type="checkbox"][value="EPOST"]'),
          display.includes('EPOST'),
        )
        applyCheckedState(groupRoot.querySelector('input[type="checkbox"][value="PORTAL"]'), false)
      }
      saveState.lastPrefs = display
    } finally {
      saveState.applyingRules = prevApplying
    }
  }

  const setupEditCheckboxes = (groupRoot) => {
    const portal = groupRoot.querySelector('input[value="PORTAL"]')?.closest('.ant-checkbox-wrapper')
    const epost = groupRoot.querySelector('input[value="EPOST"]')?.closest('.ant-checkbox-wrapper')
    const manual = groupRoot.querySelector('input[value="MANUAL"]')?.closest('.ant-checkbox-wrapper')
    if (!portal || !epost || !manual) return false

    ensureLuxCheckboxStyles()
    portal.setAttribute(ATTR, 'portal-hidden')

    const spans = epost.querySelectorAll('span')
    spans.forEach((span) => {
      if (span.classList.contains('ant-checkbox') || span.classList.contains('ant-checkbox-inner')) return
      if (span.textContent && /E-?\s*POST/i.test(span.textContent.trim())) {
        span.textContent = 'E-Post'
      }
    })

    let emailLabel = groupRoot.querySelector(`[${ATTR}="email-label"]`)
    if (!emailLabel) emailLabel = createLuxCheckbox('EMAIL', 'E-Mail', 'email')

    let benachrichtigungLabel = groupRoot.querySelector(`[${ATTR}="benachrichtigung-label"]`)
    if (!benachrichtigungLabel) {
      benachrichtigungLabel = createLuxCheckbox('BENACHRICHTIGUNG', 'Benachrichtigung', 'benachrichtigung')
    }

    const parent = portal.parentElement
    if (!parent) return false

    // Visible order: E-Mail, Manuell, E-Post, Benachrichtigung (Portal hidden)
    parent.insertBefore(emailLabel, parent.firstChild)
    parent.insertBefore(manual, emailLabel.nextSibling)
    parent.insertBefore(epost, manual.nextSibling)
    parent.insertBefore(benachrichtigungLabel, epost.nextSibling)
    return true
  }

  const saveState =
    window.__luxKontaktierenViaSaveState ||
    (window.__luxKontaktierenViaSaveState = {
      contactId: null,
      dirty: false,
      baseline: null,
      groupRoot: null,
      luxRowMissing: false,
      speichernListenerInstalled: false,
      bypassGate: false,
      hostSpeichernReplay: null,
      releaseHostSpeichernReplayGate: null,
      applyingRules: false,
      lastPrefs: null,
      pendingImpowerPrefs: null,
    })

  /** Patch Impower contact PUT so Speichern cannot wipe MANUAL/EPOST we just saved. */
  const ensureImpowerPutInterceptor = () => {
    if (window.__luxKontaktierenViaFetchPatched) return
    window.__luxKontaktierenViaFetchPatched = true
    const originalFetch = window.fetch.bind(window)
    window.fetch = async (input, init) => {
      try {
        const url = typeof input === 'string' ? input : input?.url || ''
        const method = String(init?.method || (typeof input !== 'string' && input?.method) || 'GET').toUpperCase()
        const pending = saveState.pendingImpowerPrefs
        if (
          method === 'PUT' &&
          Array.isArray(pending) &&
          /\/services\/pmp-accounting\/api\/v1\/contacts\/\d+/.test(String(url))
        ) {
          const rawBody = init?.body
          if (typeof rawBody === 'string') {
            const body = JSON.parse(rawBody)
            if (body && typeof body === 'object') {
              body.dispatchPreferences = pending
              init = { ...init, body: JSON.stringify(body) }
            }
          }
        }
      } catch (error) {
        console.error('Error patching Impower contact PUT dispatchPreferences:', error)
      }
      return originalFetch(input, init)
    }
  }

  const markDirtyIfChanged = () => {
    if (!saveState.groupRoot || saveState.baseline == null) return
    // Prefer lastPrefs — Impower DOM input.checked is often stale after sync
    const current = Array.isArray(saveState.lastPrefs)
      ? saveState.lastPrefs.join(',')
      : readVisibleCheckedPrefs(saveState.groupRoot).join(',')
    saveState.dirty = current !== saveState.baseline
  }

  const persistDispatchPreferences = async () => {
    const contactId = getContactId()
    if (!contactId || contactId !== saveState.contactId) return true
    if (!saveState.groupRoot) return true
    if (!saveState.dirty && !saveState.luxRowMissing) return true

    const token = getAuthToken()
    if (!token) return false

    // Prefer lastPrefs (authoritative after toggles); DOM can desync from Impower React
    const raw = Array.isArray(saveState.lastPrefs)
      ? saveState.lastPrefs
      : readVisibleCheckedPrefs(saveState.groupRoot)
    const dispatchPreferences = resolveValidPrefs(raw)
    const impowerPrefs = toImpowerPrefs(dispatchPreferences)
    applyPrefsToUi(saveState.groupRoot, dispatchPreferences, { syncImpower: true })
    // Keep until host Speichern PUT finishes (see fetch interceptor)
    saveState.pendingImpowerPrefs = impowerPrefs
    ensureImpowerPutInterceptor()

    const response = await fetch(`${baseApiUrl}${API_PATH}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ contactId: Number(contactId), dispatchPreferences }),
    })
    if (!response.ok) {
      console.error('Failed to save lux dispatch preferences', response.status)
      saveState.pendingImpowerPrefs = null
      return false
    }
    saveState.baseline = dispatchPreferences.join(',')
    saveState.dirty = false
    saveState.luxRowMissing = false
    return true
  }

  const triggerSpeichernSave = async (event) => {
    if (saveState.bypassGate) return
    const contactId = getContactId()
    if (!contactId || contactId !== saveState.contactId) return
    if (!saveState.dirty && !saveState.luxRowMissing) return

    event.preventDefault()
    event.stopPropagation()
    event.stopImmediatePropagation?.()

    if (!saveState.hostSpeichernReplay) {
      let release
      saveState.hostSpeichernReplay = new Promise((resolve) => {
        release = resolve
      })
      saveState.releaseHostSpeichernReplayGate = release
    }

    try {
      await persistDispatchPreferences()
    } catch (error) {
      console.error('Error saving lux dispatch preferences on Speichern:', error)
    } finally {
      const replay = saveState.hostSpeichernReplay
      saveState.releaseHostSpeichernReplayGate?.()
      saveState.releaseHostSpeichernReplayGate = null
      saveState.hostSpeichernReplay = null

      const button = event.target?.closest?.('button')
      if (button && replay) {
        saveState.bypassGate = true
        try {
          button.click()
        } finally {
          saveState.bypassGate = false
          // Clear after host Speichern has started its PUT (microtask + short delay)
          setTimeout(() => {
            saveState.pendingImpowerPrefs = null
          }, 5000)
        }
      } else {
        saveState.pendingImpowerPrefs = null
      }
    }
  }

  const ensureSpeichernListener = () => {
    if (saveState.speichernListenerInstalled) return
    saveState.speichernListenerInstalled = true
    document.addEventListener(
      'click',
      (event) => {
        const button = event.target?.closest?.('button')
        if (!button) return
        const text = (button.textContent || '').trim()
        if (
          text !== 'Speichern' &&
          text !== 'Speichern und Weiter' &&
          text !== 'Save' &&
          text !== 'Save and Continue'
        ) {
          return
        }
        triggerSpeichernSave(event)
      },
      true,
    )
  }

  const fetchLuxPrefs = async (contactId) => {
    const token = getAuthToken()
    if (!token) return { prefs: null, source: null, ok: false }
    try {
      const response = await fetch(`${baseApiUrl}${API_PATH}?contactId=${contactId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
      })
      if (!response.ok) return { prefs: null, source: null, ok: false }
      const data = await response.json()
      const prefs = Array.isArray(data.dispatchPreferences)
        ? normalizePrefs(data.dispatchPreferences)
        : null
      const source = data.source === 'impower' || data.source === 'lux' ? data.source : null
      return { prefs, source, ok: true }
    } catch {
      return { prefs: null, source: null, ok: false }
    }
  }

  const onImpowerPrefChange = (groupRoot, token) => {
    if (saveState.applyingRules) return
    saveState.applyingRules = true
    try {
      // Last-click wins: toggle from last known prefs (not raw DOM resolve)
      const current = saveState.lastPrefs || readVisibleCheckedPrefs(groupRoot)
      const next = togglePref(current, token)
      applyPrefsToUi(groupRoot, next, { syncImpower: true })
      markDirtyIfChanged()
    } finally {
      saveState.applyingRules = false
    }
  }

  const initEdit = async () => {
    const contactId = getContactId()
    if (!contactId) return false
    const contactIdStr = String(contactId)

    const portalInput = document.querySelector('input[type="checkbox"][value="PORTAL"]')
    if (!portalInput) return false

    const groupRoot =
      portalInput.closest('.ant-checkbox-group') ||
      portalInput.closest('[class*="checkbox"]')?.parentElement ||
      portalInput.closest('.sub-section-content') ||
      portalInput.parentElement?.parentElement?.parentElement

    if (!groupRoot) return false
    if (groupRoot.getAttribute(ATTR) === `edit-${contactIdStr}`) return true

    if (!setupEditCheckboxes(groupRoot)) return false
    groupRoot.setAttribute(ATTR, `edit-${contactIdStr}`)

    const emailInput = groupRoot.querySelector(`[${ATTR}="email-input"]`)
    const benachrichtigungInput = groupRoot.querySelector(`[${ATTR}="benachrichtigung-input"]`)
    const impowerPrefs = getImpowerCheckedPrefsFromDom(groupRoot)

    const editFetchGeneration =
      window.__luxKontaktierenViaEditFetchGen ||
      (window.__luxKontaktierenViaEditFetchGen = { value: 0 })
    editFetchGeneration.value += 1
    const fetchGen = editFetchGeneration.value

    let luxPrefs = null
    let prefsSource = null
    try {
      const fetched = await fetchLuxPrefs(contactId)
      luxPrefs = fetched.prefs
      prefsSource = fetched.source
    } catch (error) {
      console.error('Error loading lux dispatch preferences:', error)
    }

    // Late response: contact/route/DOM may have changed (matches view-mode guards)
    if (fetchGen !== editFetchGeneration.value) return false
    if (String(getContactId() || '') !== contactIdStr) return false
    if (!groupRoot.isConnected) return false
    if (groupRoot.getAttribute(ATTR) !== `edit-${contactIdStr}`) return false

    const effective = luxPrefs != null ? luxPrefs : resolveEffective(null, impowerPrefs)
    // Open: priority-sanitize so old multi-checked saves auto-uncheck to one valid combo
    const loadedKey = prefsAsSavedVisible(effective).join(',')
    const resolved = resolveValidPrefs(effective)
    applyPrefsToUi(groupRoot, resolved, { syncImpower: true })

    saveState.contactId = contactIdStr
    saveState.groupRoot = groupRoot
    // Keep baseline as what was saved so sanitize marks Speichern dirty until persist
    saveState.baseline = loadedKey
    saveState.dirty = resolved.join(',') !== loadedKey
    saveState.luxRowMissing = prefsSource === 'impower'

    bindLuxOwnedCheckbox(emailInput, 'EMAIL', markDirtyIfChanged)
    bindLuxOwnedCheckbox(benachrichtigungInput, 'BENACHRICHTIGUNG', markDirtyIfChanged)

    groupRoot.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      if (input.dataset.luxKontaktierenBound === '1') return
      input.dataset.luxKontaktierenBound = '1'
      const value = (input.value || '').toUpperCase()
      if (value === 'EMAIL' || value === 'BENACHRICHTIGUNG') return
      if (value === 'PORTAL') return
      if (value !== 'MANUAL' && value !== 'EPOST') return
      // Capture intended token before Ant/React mutates; use toggle from lastPrefs
      input.addEventListener(
        'click',
        (e) => {
          if (saveState.applyingRules) return
          e.preventDefault()
          e.stopPropagation()
          onImpowerPrefChange(groupRoot, value)
        },
        true,
      )
    })

    ensureSpeichernListener()
    return true
  }

  const viewPendingByContactId =
    window.__luxKontaktierenViaViewPending || (window.__luxKontaktierenViaViewPending = {})
  const viewAppliedByContactId =
    window.__luxKontaktierenViaViewApplied || (window.__luxKontaktierenViaViewApplied = {})
  const viewFetchGeneration =
    window.__luxKontaktierenViaViewFetchGen || (window.__luxKontaktierenViaViewFetchGen = { value: 0 })

  const ensureViewValueStyles = () => {
    if (document.getElementById('lux-kontaktieren-via-view-style')) return
    const style = document.createElement('style')
    style.id = 'lux-kontaktieren-via-view-style'
    style.textContent = `
      [data-lux-kontaktieren-via="view-impower-hidden"] {
        display: none !important;
      }
      [data-lux-kontaktieren-via="view-value"][data-lux-loading="1"] {
        opacity: 0.55;
      }
    `
    document.head.appendChild(style)
  }

  const initView = async () => {
    const contactId = getContactId()
    if (!contactId) return false
    const contactIdStr = String(contactId)

    const labelEl = findKontaktierenViaLabelEl()
    if (!labelEl) return false

    ensureViewValueStyles()

    let impowerValueEl = labelEl.nextElementSibling
    if (
      !impowerValueEl ||
      impowerValueEl.classList?.contains('label') ||
      impowerValueEl.getAttribute(ATTR) === 'view-value'
    ) {
      impowerValueEl =
        Array.from(labelEl.parentElement?.children || []).find(
          (el) =>
            el !== labelEl &&
            el.classList?.contains('value') &&
            el.getAttribute(ATTR) !== 'view-value',
        ) || null
    }

    let luxValueEl = labelEl.parentElement?.querySelector(`[${ATTR}="view-value"]`)
    if (!luxValueEl) {
      luxValueEl = document.createElement(impowerValueEl?.tagName || 'div')
      luxValueEl.className = impowerValueEl?.className || 'value'
      luxValueEl.setAttribute(ATTR, 'view-value')
      if (impowerValueEl) {
        impowerValueEl.setAttribute(ATTR, 'view-impower-hidden')
        impowerValueEl.insertAdjacentElement('afterend', luxValueEl)
      } else {
        labelEl.insertAdjacentElement('afterend', luxValueEl)
      }
    } else if (impowerValueEl && impowerValueEl.getAttribute(ATTR) !== 'view-impower-hidden') {
      impowerValueEl.setAttribute(ATTR, 'view-impower-hidden')
    }

    const marker = `view-${contactIdStr}`
    const boundContactId = luxValueEl.getAttribute('data-lux-contact-id')

    if (boundContactId && boundContactId !== contactIdStr) {
      luxValueEl.removeAttribute('data-lux-applied')
      luxValueEl.setAttribute('data-lux-loading', '1')
      luxValueEl.textContent = 'Lade...'
      luxValueEl.setAttribute('data-lux-contact-id', contactIdStr)
    }

    if (luxValueEl.getAttribute('data-lux-applied') === marker) return true

    const cached = viewAppliedByContactId[contactIdStr]
    if (cached != null) {
      luxValueEl.textContent = cached
      luxValueEl.setAttribute('data-lux-contact-id', contactIdStr)
      luxValueEl.setAttribute('data-lux-applied', marker)
      luxValueEl.removeAttribute('data-lux-loading')
      luxValueEl.removeAttribute('data-lux-fetch-failed-at')
      return true
    }

    // Throttle retries after a failed Lux GET (do not session-cache Impower fallback)
    const failedAt = Number(luxValueEl.getAttribute('data-lux-fetch-failed-at') || 0)
    if (failedAt && Date.now() - failedAt < 15000) {
      return true
    }

    if (viewPendingByContactId[contactIdStr]) {
      if (luxValueEl.getAttribute('data-lux-loading') !== '1') {
        luxValueEl.setAttribute('data-lux-loading', '1')
        luxValueEl.setAttribute('data-lux-contact-id', contactIdStr)
        luxValueEl.textContent = 'Lade...'
      }
      return true
    }

    viewPendingByContactId[contactIdStr] = true
    viewFetchGeneration.value += 1
    const fetchGen = viewFetchGeneration.value

    luxValueEl.setAttribute('data-lux-contact-id', contactIdStr)
    luxValueEl.setAttribute('data-lux-loading', '1')
    luxValueEl.textContent = 'Lade...'
    luxValueEl.removeAttribute('data-lux-applied')

    let luxPrefs = null
    let fetchOk = false
    try {
      const fetched = await fetchLuxPrefs(contactId)
      luxPrefs = fetched.prefs
      fetchOk = fetched.ok === true
    } catch (error) {
      console.error('Error loading lux dispatch preferences (view):', error)
      fetchOk = false
    } finally {
      delete viewPendingByContactId[contactIdStr]
    }

    if (fetchGen !== viewFetchGeneration.value) return false
    if (String(getContactId() || '') !== contactIdStr) return false
    if (!luxValueEl.isConnected) return false
    if (luxValueEl.getAttribute('data-lux-contact-id') !== contactIdStr) return false

    const impowerText = (impowerValueEl?.textContent || '').trim()
    const impowerPrefs = []
    if (/portal/i.test(impowerText) || /kunden\s*portal/i.test(impowerText) || /benachrichtigung/i.test(impowerText)) {
      impowerPrefs.push('PORTAL')
    }
    if (/e-?\s*mail/i.test(impowerText)) impowerPrefs.push('EMAIL')
    if (/manuell/i.test(impowerText)) impowerPrefs.push('MANUAL')
    if (/e-?\s*post/i.test(impowerText)) impowerPrefs.push('EPOST')

    const effective = luxPrefs != null ? luxPrefs : resolveEffective(null, impowerPrefs)
    const nextText = formatLabels(effective)
    // Only session-cache successful Lux API responses — failed fetches must retry later
    if (fetchOk) {
      viewAppliedByContactId[contactIdStr] = nextText
      luxValueEl.setAttribute('data-lux-applied', marker)
      luxValueEl.removeAttribute('data-lux-fetch-failed-at')
    } else {
      luxValueEl.removeAttribute('data-lux-applied')
      luxValueEl.setAttribute('data-lux-fetch-failed-at', String(Date.now()))
    }
    luxValueEl.removeAttribute('data-lux-loading')
    luxValueEl.textContent = nextText
    return true
  }

  if (mode === 'view') {
    return initView()
  }
  return initEdit()
}

window.initKontaktierenViaDispatchPreferences = initKontaktierenViaDispatchPreferences
